// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordRequirements_root__aaQTI","item":"PasswordRequirements_item__vfgRC"};